import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@tonic-ui/react';
import ErrorHandler from '../../components/error-handler/error-handler';

type ErrorPageProps = {
  errorCode: number;
};

const ErrorPage = ({ errorCode = 500 }: ErrorPageProps): JSX.Element => {
  const { t } = useTranslation();
  const errorMessage = t(errorCode >= 400 && errorCode < 500 ? 'error4xx' : 'error5xx');

  return (
    <Stack height="100%" justifyContent="center" alignItems="center">
      <ErrorHandler title={`${errorCode} - ${errorMessage}`} id="support-form-error-page">
        {t(errorCode === 504 ? 'support.supportPage.body504Error' : 'error5xx')}
      </ErrorHandler>
    </Stack>
  );
};

ErrorPage.displayName = 'ErrorPage';

export default ErrorPage;
